import { Component, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MasterDataService } from '../../services/master-data.service';
import { HumanResourceService } from '../../services/human-resource.service';
import jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { BranchFilterService } from 'src/app/services/branch-filter.service';


@Component({
  selector: 'app-expense-reimbursement-report',
  templateUrl: './expense-reimbursement-report.component.html',
  styleUrls: ['./expense-reimbursement-report.component.css']
})
export class ExpenseReimbursementReportComponent implements OnInit {
  branchList;
  clientList;
  financialList;
  assignmentList;
  billingDateList;
  branch;
  client;
  assignment;
  selectedClientStatus;
  selectedFinancialYear;
  selectBillingDate;
  reportList;
  isAssignmentSelected: boolean;
  userRole;
  accessResponse: any;

  constructor(private masterDataService: MasterDataService,
    private humanResourceService: HumanResourceService, private commonMessageService: CommonMessageService,
    private branchFilterService: BranchFilterService
  ) { }

  ngOnInit(): void {
    this.selectedFinancialYear = "";
    this.branch = "";
    this.client = "";
    this.selectedClientStatus = "";
    this.selectBillingDate = "";
    this.loadInitialDetails();
  }

  loadInitialDetails() {
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
  }

  onSelectFinancialYear() {
    this.branch = "";
    this.client = "";
    this.selectBillingDate = "";
    this.assignmentList = [];
    this.showExportToExcelButton = false;

    // this.masterDataService.getBranch().subscribe((res) => {
    //   this.branchList = res;
    // });
    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });
  }

  onStatusSelect() {
    this.client = "";
    this.selectBillingDate = "";
    this.assignmentList = [];
    this.showExportToExcelButton = false;
    console.log('this.branch', this.branch, this.selectedClientStatus);
    this.masterDataService.getClientListByBranchStatus(this.branch, this.selectedClientStatus).subscribe((resp: any) => {
      console.log('response details client list', resp);
      this.clientList = resp;
    });
  }

  onSelectBranch() {
    this.client = "";
    this.selectedClientStatus = "";
    this.selectBillingDate = "";
    this.assignmentList = [];
    this.showExportToExcelButton = false;

    // this.humanResourceService
    //   .getClientsByBranch(this.branch)
    //   .subscribe((res: any) => {
    //     console.log('response details', res);
    //     if (res.length > 0) {
    //       this.clientList = res;
    //     } else {
    //        this.commonMessageService.swalAlertWithoutIcon('','Client not present for this Branch');
    //     }
    //   });
  }

  onSelectClient() {
    this.humanResourceService
      .getClientBillingDate(
        this.client,
        this.selectedFinancialYear.id
      )
      .subscribe((res: any) => {
        console.log('billing date list', res);
        this.billingDateList = res;
      });
  }

  selectAllAssignment(select: NgModel, values) {
    this.selectAll(select, values, this.isAssignmentSelected);
    this.isAssignmentSelected = !this.isAssignmentSelected;
  }

  selectAll(select: NgModel, values, isSelected) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  onBillingDateSelect() {
    console.log('select billing date', this.selectBillingDate.id)
    this.assignmentList = [];
    this.showExportToExcelButton = false;

    this.humanResourceService
      .getClientAssignmentByBillDate(this.client, this.selectBillingDate.id)
      .subscribe((res: any) => {
        this.assignmentList = res;
      });
  }

  showExportToExcelButton: boolean;
  assignmentId;
  viewReport() {
    console.log('this', this.reportList);
    if (this.selectedFinancialYear == "" || this.selectedFinancialYear == null || this.selectedFinancialYear == undefined ||
      this.branch == "" || this.branch == null || this.branch == undefined || this.client == "" || this.client == null || this.client == undefined ||
      this.selectBillingDate == "" || this.selectBillingDate == null || this.selectBillingDate == undefined ||
      this.assignment == null || this.assignment.length == 0) {
      this.commonMessageService.swalAlertWithoutIcon('', "Please select all values.");
      return;
    }
    this.assignmentId = this.assignment.map(({ id }) => id);
    this.humanResourceService.getReimbursementReportDetails(this.selectedClientStatus, this.client, this.selectBillingDate.id, this.assignmentId).subscribe((resp: any) => {
      console.log('response details', resp);
      this.reportList = resp;
      this.showExportToExcelButton = true;
    });
  }

  exportToExcelForReimbursementReport() {
    this.humanResourceService.getReimbursementReportExcel(this.selectedClientStatus, this.client, this.selectBillingDate.id, this.assignmentId).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "ExpenseReimbursementReport.xlsx";
      link.click();
    });
  }

  convertReimbursementReportIntoPDF() {
    var data = document.getElementById('contentToConvert');
    html2canvas(data).then(canvas => {
      var imgWidth = 208;
      var imgHeight = canvas.height * imgWidth / canvas.width;

      const contentDataURL = canvas.toDataURL('image/png')
      let pdf = new jspdf(); // A4 size page of PDF  
      pdf.addImage(contentDataURL, 0, 0, imgWidth, imgHeight);
      pdf.save('ExpenseReimbursementReport.pdf'); // Generated PDF   
    });
  }
}
















